import {Decimal} from 'decimal.js'

export function roundMoney(num: number) {
	return new Decimal(num).toDecimalPlaces(2).toNumber();
}
